import React from "react";

export const LouiseBadgeIcon = ({
  theme = "original",
  width = "32px",
  height = "32px"
}: {
  theme?: "SILVER" | "BRONZE" | "GOLD" | "STANDARD";
  width?: string;
  height?: string;
}) => {
  const getBackgroundColor = () => {
    switch (theme) {
      case "SILVER":
        return "#C0C0C0";
      case "BRONZE":
        return "#CD7F32";
      case "GOLD":
        return "#f1c92b";
      case "STANDARD":
        return "#312ee3";
      default:
        return "#312ee3";
    }
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
    >
      <circle cx="256" cy="256" r="256" fill={getBackgroundColor()} />
      <path
        d="M432,120H288.62V51.38L220,120,80,260V392H223.38v68.62L292,392h0l70-70h70V252h0ZM150,322V190H362v30.92h0V322Z"
        fill="#fff"
      />
    </svg>
  );
};
